import styled from 'styled-components';

export const StyledBookContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 240px;
  height: 384px;
  background-color: #c4c4c4;
  padding: 22px 14px;
  cursor: pointer;
`;

export const StyledBookTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
`;

export const StyledBookDesc = styled.div`
  margin-top: 5px;
  font-size: 10px;
`;

export const StyledBookInfo = styled.div`
  color: #fbfbfb;
  font-size: 8px;
  font-weight: 400;
`;

export const StyledHorizontalLine = styled.div`
  width: 194px;
  border-bottom: 1px solid #8b8b8b;
  margin-top: 3px;
  margin-bottom: 5px;
`;

export const StyledImgContainer = styled.div`
  width: 180px;
  height: 288px;
  background-color: #e1e1e1;
  margin: 4px 0px;
`;
